export const TYPE_MENU = 'menu';
export const TYPE_LINK = 'link';
export const TYPE_ROOT = 'root';
export const TYPE_HTML = 'html';
